import { PartnerType } from "@/app/utils/partners.enum";
import { httpClient } from "../http/httpClient";

export type SimulationRequest = {
  produtoId?: number;
  convenioId?: number;
  tabelaJurosId?: number;
  diaRecebimentoId?: number;
  vencimento?: string;
  valor?: number;
  valorRenda?: number;
  tipoCalculo?: number;
  valorDebitoConcorrente?: number;
  contrato?: number;
  recalculo?: string;
};

export type CreditLimit = {
  valorMaximoSolicitado: number;
  valorMaximoParcela: number;
  valorMinimoParcela: number;
};

export type PrazoValor = {
  prazo: number;
  valorParcela: number;
  valorSolicitado: number | null;
};

export type SimulationResponse = {
  propostaId: string;
  vencimento: string;
  vencimentos: string[];
  valorLimite: CreditLimit;
  produtoId: number;
  tabelaJurosId: number;
  diaRecebimentoId: number;
  valorSolicitado: number;
  tipoCalculo: number;
  prazoValor: PrazoValor[];
  commission: number;
};

export async function postSimulation(
  preTransactionId: string,
  payload: SimulationRequest = {},
): Promise<SimulationResponse> {
  const { data } = await httpClient
    .post<SimulationResponse>(
      `/crefaz-clt/${preTransactionId}/simulation`,
      payload,
      { journey: PartnerType.CREFAZ_CLT },
    )
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}
